var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzzleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.365 86.3a1.5 1.5 0 0 1-1.5-1.5V62.059a12.152 12.152 0 0 1 0-24.118V15.2a1.5 1.5 0 0 1 3 0v24.149a1.5 1.5 0 0 1-1.5 1.5 9.151 9.151 0 0 0 0 18.3 1.5 1.5 0 0 1 1.5 1.5V84.8a1.5 1.5 0 0 1-1.5 1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27.349A12.172 12.172 0 0 1 37.94 16.7H19.365a1.5 1.5 0 0 1 0-3h19.984a1.5 1.5 0 0 1 1.5 1.5 9.151 9.151 0 0 0 18.3 0 1.5 1.5 0 0 1 1.5-1.5h19.986a1.5 1.5 0 0 1 0 3H62.06A12.172 12.172 0 0 1 50 27.349Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.635 86.3a1.5 1.5 0 0 1-1.5-1.5V60.651a1.5 1.5 0 0 1 1.5-1.5 9.151 9.151 0 0 0 0-18.3 1.5 1.5 0 0 1-1.5-1.5V15.2a1.5 1.5 0 1 1 3 0v22.741a12.152 12.152 0 0 1 0 24.118V84.8a1.5 1.5 0 0 1-1.5 1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.635 86.3H60.651a1.5 1.5 0 0 1-1.5-1.5 9.151 9.151 0 0 0-18.3 0 1.5 1.5 0 0 1-1.5 1.5H19.365a1.5 1.5 0 1 1 0-3H37.94a12.153 12.153 0 0 1 24.12 0h18.575a1.5 1.5 0 0 1 0 3Zm-19.918-41-6.569-.955-2.939-5.952a1.348 1.348 0 0 0-2.418 0l-2.938 5.952-6.57.955a1.349 1.349 0 0 0-.748 2.3l4.755 4.634-1.123 6.543a1.348 1.348 0 0 0 1.957 1.423L50 57.111l5.877 3.089a1.348 1.348 0 0 0 1.956-1.421l-1.123-6.543 4.755-4.636a1.349 1.349 0 0 0-.748-2.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzleStar);
export default __webpack_public_path__ + "static/media/puzzle-star.130ef0b79dc84f9f42cd132a7874a5d1.svg";
export { ForwardRef as ReactComponent };